module.exports = __webpack_public_path__ + "static/media/idveriufation.8ae762ce.png";